<template>
  <v-menu offset-y bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" class="d-flex align-center click_cursor">
        {{ currentLocale === 'de' ? 'DE' : 'EN' }}
        <v-icon small right>mdi-chevron-down</v-icon>
      </span>
    </template>
    <v-list dense>
      <v-list-item
        v-for="lang in languages"
        :key="lang.value"
        @click="setLanguage(lang.value)"
        :class="{ 'primary--text': currentLocale === lang.value }"
      >
        <v-list-item-title>{{ lang.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import i18nMixin from '@/mixins/i18nMixin'

export default {
  name: 'LanguageSwitcher',
  mixins: [i18nMixin],
  data() {
    return {
      languages: [
        { value: 'de', label: 'Deutsch' },
        { value: 'en', label: 'English' }
      ]
    }
  }
}
</script>
